import { Link } from 'react-router-dom';

export default function Footer() {
  const footerLinks = {
    热门分类: [
      { to: '/category/dianying', label: '电影在线观看' },
      { to: '/category/dianshiju', label: '电视剧全集' },
      { to: '/category/dongman', label: '动漫番剧' },
      { to: '/category/zongyi', label: '综艺节目' },
      { to: '/category/jilupian', label: '纪录片' },
    ],
    关于我们: [
      { to: '/about', label: '品牌介绍' },
      { to: '/about', label: '联系我们' },
      { to: '/about', label: '用户口碑' },
    ],
    友情链接: [
      { to: '#', label: '西瓜视频免费' },
      { to: '#', label: '91在线视频' },
      { to: '#', label: '小蓝视频' },
      { to: '#', label: '久久视频' },
    ],
  };

  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-play-fill text-white text-lg"></i>
              </div>
              <span className="text-xl font-bold font-heading text-foreground-900 whitespace-nowrap">
                番茄视频
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              汇集西瓜视频免费、91在线视频、小蓝视频、久久视频等平台资源，提供电影电视剧全集免费在线观看。
            </p>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-foreground-900 mb-3 whitespace-nowrap">
                {title}
              </h4>
              <ul className="space-y-2">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 番茄视频 fanqieshipin.com 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap">服务条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}